import { useEffect, useState } from 'react';
import { useAppStore } from '@/state/store';
import { parseModelName } from '@/types/library';
import { saveToLibrary } from '@/lib/api/libraryApi';

export function SaveToLibrary() {
  const model = useAppStore((s) => s.model);
  const rawFiles = useAppStore((s) => s.rawFiles);
  const pushStatus = useAppStore((s) => s.pushStatus);

  const [modelName, setModelName] = useState('');
  const [sizeLabel, setSizeLabel] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (!model) return;
    const parsed = parseModelName(model.modelName);
    setModelName(parsed.modelName);
    setSizeLabel(parsed.sizeLabel);
  }, [model?.id]);

  if (!model) return null;

  const sourceFormat = /\.tur$/i.test(model.fileName) ? 'TUR' : 'C';

  async function handleSave() {
    if (!model) return;
    if (!modelName.trim() || !sizeLabel.trim()) {
      pushStatus('warning', 'Enter both a model name and a size before saving.');
      return;
    }
    setIsSaving(true);
    try {
      await saveToLibrary({
        modelName: modelName.trim(),
        sizeLabel: sizeLabel.trim(),
        sourceFormat,
        lengthMm: model.metrics.length,
        barrelDiameterMm: model.metrics.barrelDiameter,
        handleDiameterMm: model.metrics.handleDiameter,
        knobDiameterMm: model.metrics.knobDiameter,
        profilePoints: model.metrics.totalProfilePoints,
        autoTrimConfidence: model.trim.confidence,
        files: rawFiles,
      });
      pushStatus(
        'success',
        `Saved "${modelName.trim()}" size ${sizeLabel.trim()} to the library (${rawFiles.length} file(s) attached).`,
      );
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to save to the library.';
      pushStatus('error', message);
    } finally {
      setIsSaving(false);
    }
  }

  return (
    <div>
      <div className="sidebar-section-label">Save to Library</div>
      <div className="btn-group">
        <div className="btn-row">
          <input
            value={modelName}
            onChange={(e) => setModelName(e.target.value)}
            placeholder="Model name"
            style={{
              flex: 1,
              padding: '8px 10px',
              borderRadius: 7,
              border: '1px solid var(--border-default)',
              background: 'var(--bg-input)',
              color: 'var(--text-primary)',
              fontSize: 12.5,
            }}
          />
          <input
            value={sizeLabel}
            onChange={(e) => setSizeLabel(e.target.value)}
            placeholder="Size"
            style={{
              width: 64,
              padding: '8px 10px',
              borderRadius: 7,
              border: '1px solid var(--border-default)',
              background: 'var(--bg-input)',
              color: 'var(--text-primary)',
              fontSize: 12.5,
            }}
          />
        </div>
        <button className="btn btn-primary" disabled={isSaving} onClick={handleSave}>
          {isSaving ? 'Saving…' : `Save Model & Size (${rawFiles.length} file${rawFiles.length === 1 ? '' : 's'})`}
        </button>
      </div>
    </div>
  );
}
